import { Link } from 'react-router-dom';
import { MiniprogramScopeBar, useMiniprogramScopeId } from '@/components/MiniprogramScopeBar';
import { AndroidRobotApiKeyCard } from '@/components/AndroidRobotApiKeyCard';
import { PageHeader } from '@/components/ui/PageHeader';
import { Button } from '@/components/ui/Button';
import { EmptyState } from '@/components/ui/EmptyState';
import { WesRobotsAdminPage } from '@/pages/WesRobotsAdminPage';

export function RobotManagementPage() {
  const mpId = useMiniprogramScopeId();

  return (
    <div className="space-y-6">
      <nav className="flex flex-wrap items-center gap-x-1.5 gap-y-1 text-sm text-slate-500">
        <Link to="/miniprograms" className="rounded-md hover:bg-slate-100 hover:text-teal-800">
          小程序管理
        </Link>
        <span className="text-slate-300" aria-hidden>
          /
        </span>
        <span className="font-medium text-slate-800">机器人管理</span>
      </nav>

      <PageHeader
        title="机器人管理"
        description="按小程序维护 Android 转发机器人：名称、启用状态、朋友圈/群发渠道、转发站点与时间窗。管理员可查看全部；普通用户仅管理自己账号下的机器人。"
        actions={
          mpId > 0 ? (
            <Link to={`/robot-miniprograms/${mpId}`}>
              <Button type="button" variant="secondary">
                站点与转发配置
              </Button>
            </Link>
          ) : null
        }
      />

      <MiniprogramScopeBar />

      {mpId > 0 ? (
        <>
          <AndroidRobotApiKeyCard miniprogramId={mpId} />
          <WesRobotsAdminPage miniprogramId={mpId} embedded />
        </>
      ) : (
        <EmptyState>请先在上方选择小程序，再管理该小程序下的机器人。</EmptyState>
      )}
    </div>
  );
}
